import {MetaTitleDesc} from "../meta";
import DocumentMeta from "react-document-meta";
import ImageGallery from 'react-image-gallery';
import "./../image-gallery.css";

export default () => {
    const title = 'Бронная гора';

    const images = [
        {
            original: require('./../img/virtualtours/bronnayamountain/bg000.jpg'),
            thumbnail: require('./../img/virtualtours/bronnayamountain/bgm000.jpg'),
            description: 'Карта',
        },
        {
            original: require('./../img/virtualtours/bronnayamountain/bg001.jpg'),
            thumbnail: require('./../img/virtualtours/bronnayamountain/bgm001.jpg'),
            description: 'Начало',
        },
        {
            original: require('./../img/virtualtours/bronnayamountain/bg002.jpg'),
            thumbnail: require('./../img/virtualtours/bronnayamountain/bgm002.jpg'),
            description: 'Вьезд',
        },
        {
            original: require('./../img/virtualtours/bronnayamountain/bg003.jpg'),
            thumbnail: require('./../img/virtualtours/bronnayamountain/bgm003.jpg'),
            description: 'Зима',
        },
        {
            original: require('./../img/virtualtours/bronnayamountain/bg004.jpg'),
            thumbnail: require('./../img/virtualtours/bronnayamountain/bgm004.jpg'),
            description: 'Железная дорога',
        },
        {
            original: require('./../img/virtualtours/bronnayamountain/bg005.jpg'),
            thumbnail: require('./../img/virtualtours/bronnayamountain/bgm005.jpg'),
            description: 'Бронная гора',
        },
        {
            original: require('./../img/virtualtours/bronnayamountain/bg006.jpg'),
            thumbnail: require('./../img/virtualtours/bronnayamountain/bgm006.jpg'),
            description: 'Бронная гора',
        },
        {
            original: require('./../img/virtualtours/bronnayamountain/bg007.jpg'),
            thumbnail: require('./../img/virtualtours/bronnayamountain/bgm007.jpg'),
            description: 'Бронная гора',
        },
        {
            original: require('./../img/virtualtours/bronnayamountain/bg008.jpg'),
            thumbnail: require('./../img/virtualtours/bronnayamountain/bgm008.jpg'),
            description: 'Бронная гора',
        },
        {
            original: require('./../img/virtualtours/bronnayamountain/bg009.jpg'),
            thumbnail: require('./../img/virtualtours/bronnayamountain/bgm009.jpg'),
            description: 'Бронная гора',
        },
        {
            original: require('./../img/virtualtours/bronnayamountain/bg010.jpg'),
            thumbnail: require('./../img/virtualtours/bronnayamountain/bgm010.jpg'),
            description: 'Бронная гора',
        },
        {
            original: require('./../img/virtualtours/bronnayamountain/bg011.jpg'),
            thumbnail: require('./../img/virtualtours/bronnayamountain/bgm011.jpg'),
            description: 'Бронная гора',
        },
        {
            original: require('./../img/virtualtours/bronnayamountain/bg012.jpg'),
            thumbnail: require('./../img/virtualtours/bronnayamountain/bgm012.jpg'),
            description: 'Бронная гора',
        },
        {
            original: require('./../img/virtualtours/bronnayamountain/bg013.jpg'),
            thumbnail: require('./../img/virtualtours/bronnayamountain/bgm013.jpg'),
            description: 'Памятный мемориал',
        },
        {
            original: require('./../img/virtualtours/bronnayamountain/bg014.jpg'),
            thumbnail: require('./../img/virtualtours/bronnayamountain/bgm014.jpg'),
            description: 'Трагедия Бронной Горы',
        },
        {
            original: require('./../img/virtualtours/bronnayamountain/bg015.jpg'),
            thumbnail: require('./../img/virtualtours/bronnayamountain/bgm015.jpg'),
            description: 'Трагедия Бронной Горы',
        },
        {
            original: require('./../img/virtualtours/bronnayamountain/bg016.jpg'),
            thumbnail: require('./../img/virtualtours/bronnayamountain/bgm016.jpg'),
            description: 'Трагедия Бронной Горы',
        },
        {
            original: require('./../img/virtualtours/bronnayamountain/bg017.jpg'),
            thumbnail: require('./../img/virtualtours/bronnayamountain/bgm017.jpg'),
            description: 'Место расстрела',
        },
        {
            original: require('./../img/virtualtours/bronnayamountain/bg018.jpg'),
            thumbnail: require('./../img/virtualtours/bronnayamountain/bgm018.jpg'),
            description: 'Трагедия Бронной Горы',
        },
        {
            original: require('./../img/virtualtours/bronnayamountain/bg019.jpg'),
            thumbnail: require('./../img/virtualtours/bronnayamountain/bgm019.jpg'),
            description: 'Трагедия Бронной Горы',
        },
        {
            original: require('./../img/virtualtours/bronnayamountain/bg020.jpg'),
            thumbnail: require('./../img/virtualtours/bronnayamountain/bgm020.jpg'),
            description: 'Трагедия Бронной Горы',
        },
        {
            original: require('./../img/virtualtours/bronnayamountain/bg021.jpg'),
            thumbnail: require('./../img/virtualtours/bronnayamountain/bgm021.jpg'),
            description: 'Трагедия Бронной Горы',
        },
        {
            original: require('./../img/virtualtours/bronnayamountain/bg022.jpg'),
            thumbnail: require('./../img/virtualtours/bronnayamountain/bgm022.jpg'),
            description: 'Бронная гора',
        },
        {
            original: require('./../img/virtualtours/bronnayamountain/bg023.jpg'),
            thumbnail: require('./../img/virtualtours/bronnayamountain/bgm023.jpg'),
            description: 'Сосны',
        },
        {
            original: require('./../img/virtualtours/bronnayamountain/bg024.jpg'),
            thumbnail: require('./../img/virtualtours/bronnayamountain/bgm024.jpg'),
            description: 'Березы',
        },
        {
            original: require('./../img/virtualtours/bronnayamountain/bg025.jpg'),
            thumbnail: require('./../img/virtualtours/bronnayamountain/bgm025.jpg'),
            description: 'Бронная гора',
        },
        {
            original: require('./../img/virtualtours/bronnayamountain/bg026.jpg'),
            thumbnail: require('./../img/virtualtours/bronnayamountain/bgm026.jpg'),
            description: 'Памятный знак',
        },
        {
            original: require('./../img/virtualtours/bronnayamountain/bg027.jpg'),
            thumbnail: require('./../img/virtualtours/bronnayamountain/bgm027.jpg'),
            description: 'Памятный знак',
        },
        {
            original: require('./../img/virtualtours/bronnayamountain/bg028.jpg'),
            thumbnail: require('./../img/virtualtours/bronnayamountain/bgm028.jpg'),
            description: 'Памятный знак',
        },
        {
            original: require('./../img/virtualtours/bronnayamountain/bg029.jpg'),
            thumbnail: require('./../img/virtualtours/bronnayamountain/bgm029.jpg'),
            description: 'Бронная гора',
        },
        {
            original: require('./../img/virtualtours/bronnayamountain/bg030.jpg'),
            thumbnail: require('./../img/virtualtours/bronnayamountain/bgm030.jpg'),
            description: 'Железная дорога',
        },
        {
            original: require('./../img/virtualtours/bronnayamountain/bg031.jpg'),
            thumbnail: require('./../img/virtualtours/bronnayamountain/bgm031.jpg'),
            description: 'Бронная гора',
        },
        {
            original: require('./../img/virtualtours/bronnayamountain/bg032.jpg'),
            thumbnail: require('./../img/virtualtours/bronnayamountain/bgm032.jpg'),
            description: 'Бронная гора',
        },
        {
            original: require('./../img/virtualtours/bronnayamountain/bg033.jpg'),
            thumbnail: require('./../img/virtualtours/bronnayamountain/bgm033.jpg'),
            description: 'Бронная гора',
        },
        {
            original: require('./../img/virtualtours/bronnayamountain/bg034.jpg'),
            thumbnail: require('./../img/virtualtours/bronnayamountain/bgm034.jpg'),
            description: 'Переезд',
        },
        {
            original: require('./../img/virtualtours/bronnayamountain/bg035.jpg'),
            thumbnail: require('./../img/virtualtours/bronnayamountain/bgm035.jpg'),
            description: 'Дорога',
        },
        {
            original: require('./../img/virtualtours/bronnayamountain/bg036.jpg'),
            thumbnail: require('./../img/virtualtours/bronnayamountain/bgm036.jpg'),
            description: 'Выезд',
        },
    ];

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <div className="onehalf-col-cell">
                        <h2>{title}</h2>
                        <ImageGallery
                            items={images}
                            showIndex={false}
                            showBullets={true}
                            infinite={true}
                            showThumbnails={true}
                            showFullscreenButton={false}
                            showGalleryFullscreenButton={false}
                            showPlayButton={false}
                            showGalleryPlayButton={false}
                            showNav={true}
                            isRTL={false}
                            slideDuration={300}
                            slideInterval={2000}
                            slideOnThumbnailOver={false}
                            thumbnailPosition={'right'}
                            useWindowKeyDown={true}
                        />
                    </div>
                </div>

                <div className="pageitem">
                    <p>Деревня Бронная гора находится в Республике Беларусь (Брестская область, Березовский район).</p>
                    <p>Свернув с трассы М1 на Березу, вполне легко можно попасть на Бронную гору.</p>
                    <p>В одной из легенд о происхождении Бронной горы говорится:</p>
                    <p>В давние времена некий странствующий воин остановился отдохнуть на одной из местных гор, а проснувшись, не нашел своего оружия (брони). С тех пор место и гора стали здесь зваться бронными.</p>
                    <p>В другой:</p>
                    <p>В давние времена на этом месте было большое сражение, «поле» бранное, и много воинов полегло под горою и на горе. С тех пор стали называть это место и гору бранными, что позднее и трансформировалось в Бронную.</p>
                    <p>Летом на Бронной горе конечно же намного ярче - пижма, зверобой, зелень, птички поют, со всех сторон в бронногорские леса съезжаются грибники и ягодники, охотники за кабанами гоняются и зайцами... Но и зимой Бронная гора замечательный уголок белоусской природы.</p>
                    <p>В конце июня 1941 г. в Кобрин прибыла эйнзацкоманда 9, входившая в состав эйнзацгруппен «Б». В Кобрине были расстреляны около 170 евреев. 25 июля немцы и подразделения белорусской полиции в урочище возле Бронной горы расстреляли всех обитателей гетто «Б».</p>
                    <p>В середине октября 1942 года тысячи людей еврейской национальности, проживающие в Бресте, были убиты прямо в своих домах. Около 17 тысяч узников вывезли в теплушках на «Бронную Гору», и расстреляли. До войны в городе над Бугом проживали почти 25 тысяч евреев, а после оккупации в живых осталось только 19 человек.</p>
                    <p>До войны в городе над Бугом проживали почти 25 тысяч евреев, а после оккупации в живых осталось только 19 человек.</p>
                    <p>Установлено, что массовые убийства брестских евреев происходили летом и осенью 1942 года в урочище Бронная Гора Березовского района. В общей сложности здесь было уничтожено более 50 тысяч человек разных национальностей. Шесть огромных могил для них по приказу гитлеровцев выкопали недалеко от железнодорожной станции Бронная Гора местные жители. Позднее, чтобы скрыть следы своих страшных преступлений, фашисты расстреляли и их - так погибло еще около тысячи человек. В марте 1944 года гитлеровцы пригнали на Бронную Гору около сотни мирных граждан, которых заставили раскопать еврейские могилы и сжечь трупы. Страшные костры, не переставая, горели в течение двух недель. Свидетели этого события также были расстреляны нацистскими извергами.</p>
                    <blockquote>
                        <h4>д. Бронная Гора. Соколовский сельсовет</h4>
                        <p>265. МЕСТО МАССОВОГО УНИЧТОЖЕНИЯ СОВЕТСКИХ ГРАЖДАН (ист.). В 400 м к северо-западу от деревни, в урочище Бронная Гора.</p>
                        <p>В мае — июне 1942 г, по приказу гитлеровцев в урочище было выкопано 8 ям длиной 45—60 м, шириной 6 — 6,5 м, глубиной 4 м, площадка обнесена колючей проволокой. Из Берёзы, Бреста, Городца, Дрогичина, Иванова, Кобрина, Пинска по железнодорожной ветке, которая проходила через площадку с ямами-могилами, доставляли эшелоны с узниками, преимущественно с женщинами, детьми и стариками. Их заставляли раздеваться, по проволочным коридорам гнали к ямам, приказывали ложиться рядами и расстреливали из автоматов. К концу ноября 1942 г. гитлеровцы уничтожили здесь более 50 тыс. человек. Чтобы замести следы своих преступлений, в марте 1944 г, они пригнали сюда 100 узников, которые 2 недели откапывали и жгли трупы, а затем сами были расстреляны и сожжены. Урочище Бронная Гора как место массового уничтожения советских людей увековечено в мемориальном комплексе «Хатынь».</p>
                        <p>Лит.: Преступлении немецко-фашистских оккупантов в Белоруссии, 1941 —1944. [2 изд.]. Мн., 1965; Нацистская политика геноцида и «выжженной земли» в Белоруссии, 1941 — 1944. Мн., 1984. Я. Д. Сикорин. СВОД ПАМЯТНИКОВ ИСТОРИИ И КУЛЬТУРЫ БЕЛОРУССИИ. Минск. «Белорусская советская энциклопедия» 1990 г.</p>
                    </blockquote>
                    <p>Железнодорожная станция «Бронная гора» Адрес: 225213, Брестская обл., Березовский р-н, д. Бронная Гора тел.: (+375 1643) 5-23-72 Вид деятельности: - текущая и предварительная продажа билетов</p>
                </div>
            </div>
        </>
    );
}